import '../src/app/configuration/dispatch-zone/zone-maps/configuration-map';
import '../src/app/configuration/dispatch-zone/zone-maps/leaflet-draw-init';

import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { environment } from './environments/environment';
import 'hammerjs';
import { AppModule } from './app/app-module';

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, {
  
})
  .catch(err => console.error(err));